// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"bd5acddb","931":"205ec5b9"}[chunkId] + ".chunk.css";
};